import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ConfigurationState} from '../reducers/configuration.reducer';

export const configurationFeatureKey = 'configuration';
export const selectConfigurationState = createFeatureSelector<ConfigurationState>(configurationFeatureKey);

export const selectCancellationUrl = createSelector(selectConfigurationState, (state) => state.cancellationUrl);
